import MobileDetect from 'mobile-detect'

const md = new MobileDetect(window.navigator.userAgent)

export const phone = () => md.phone()
export const mobile = () => md.mobile()
export const os = () => md.os()

export default md
